import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button } from '@sololearnorg/sol';

import { ActionType, RequestType } from '../../../global-interface';
import { SlLEContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { ILPReasonsData, IReasonItem } from '../../../../../api/private/learn-engine-api/landing-page-api.interface';
import { Container } from '../../../../../symphony';

import s from './ReasonsSection.scss';

interface IReasonsSectionProps {
	data: ILPReasonsData;
}
export function ReasonsSection({ data }: IReasonsSectionProps): JSX.Element {
	useStyles(s);
	const { title, actionBtnText, reasons } = data;

	const startLearing = () => {
		const { actions$ } = Container.take(SlLEContext, SlActions);

		actions$.next({
			type: ActionType.OnLandingPageCTAClick,
			requestType: RequestType.Parallel,
		});
	};

	return (
		<section className="lp-reasons-section">
			<div className="lp-reasons-section__container">
				<h3 className="lp-reasons-section__title">{title}</h3>
				{reasons && (
					<div className="lp-reasons-section__reasons-box">
						{reasons.map(
							({
								id,
								imgUrl,
								text,
								title: reasonTitle,
							}: IReasonItem) => (
								<article
									key={id}
									className="lp-reasons-section__reason"
								>
									<div className="lp-reasons-section__reason-img">
										<img src={imgUrl} alt="illustration" />
									</div>
									<div className="lp-reasons-section__reason-title">
										{reasonTitle}
									</div>
									<p className="lp-reasons-section__reason-text">
										{text}
									</p>
								</article>
							),
						)}
					</div>
				)}
				<Button
					onClick={startLearing}
					size="m"
					className="lp-reasons-section__action-btn"
				>
					{actionBtnText}
				</Button>
			</div>
		</section>
	);
}
